import Link from 'next/link';
import type { ReactElement } from 'react';

import { AdWrapper } from '@/components/store/components/Ad/Ad.styled';

export interface AdProps {
  alt: string;
  destination: string;
  isSticky?: boolean;
  mobileOnly?: boolean;
  src: string;
  srcWebp?: string;
}

export const Ad = ({
  alt,
  src,
  srcWebp,
  destination,
  mobileOnly,
  isSticky = true,
}: AdProps): ReactElement => (
  <AdWrapper mobileOnly={mobileOnly} isSticky={isSticky}>
    <Link href={destination}>
      <picture>
        {srcWebp && <source type="image/webp" srcSet={srcWebp} />}
        <img src={src} alt={alt} />
      </picture>
    </Link>
  </AdWrapper>
);
